module.exports = __webpack_public_path__ + "media/images/emblems/PonteCapriasca-coat_of_arms-f3a25139e819aaef6a2d7f7dc53d6511.svg";